import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { Text } from "../components/Text";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { formatBytes } from "../lib/formatBytes";

function pathFromInput(input: ToolUseProps["toolUse"]["input"]) {
  const path =
    input && typeof input === "object" && !Array.isArray(input)
      ? (input as Record<string, unknown>).path
      : null;
  return typeof path === "string" ? path : null;
}

function ReadStorageFileHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const path = pathFromInput(toolUse.input);
  const fileName = path ? path.slice(path.lastIndexOf("/") + 1) : "file";
  return (
    <ToolStatus
      icon="notebook-text"
      text={result ? `Read ${fileName}` : `Reading ${fileName}…`}
      pending={!result && !interrupted}
    />
  );
}

function ReadStorageFileBody({ toolUse, result }: ToolUseProps) {
  const path = pathFromInput(toolUse.input);
  const output =
    result?.output && typeof result.output === "object"
      ? (result.output as {
          mediaType?: unknown;
          sizeBytes?: unknown;
          error?: unknown;
        })
      : null;
  const error = result?.isError
    ? typeof result.output === "string"
      ? result.output
      : String(output?.error ?? "")
    : null;
  const details =
    typeof output?.mediaType === "string" &&
    typeof output.sizeBytes === "number"
      ? `${output.mediaType}, ${formatBytes(output.sizeBytes)}`
      : null;
  return (
    <Text variant="code-small" color="var(--text-secondary)">
      {path && <div style={{ wordBreak: "break-word" }}>{path}</div>}
      {details && <div>{details}</div>}
      {error && <div style={{ color: "var(--red-600)" }}>{error}</div>}
    </Text>
  );
}

export const readStorageFile: ChatTool = {
  name: "readStorageFile",
  Header: ReadStorageFileHeader,
  Body: ReadStorageFileBody,
};
